import { useEffect, useRef } from 'react';
import { FAIcon, IconStyle, useTranslation } from '@nextgen-web-framework/all';
import { uniqueId } from '@nextgen-web-framework/core';
import styles from './EllipsisMenu.module.scss';
import { EllipsisMenuProps } from './types/propsType';

export function EllipsisMenu({
  showMenu = false,
  onClick = () => null,
  data,
  onBlur = () => null,
  onOutsideClick,
}: EllipsisMenuProps) {
  const ref = useRef<HTMLDivElement>();
  const t = useTranslation();
  const allAllToList = t('cart.cartEllipsis.addAllToList');
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event?.target as Node)) {
        onOutsideClick?.();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);

  function handleClick(
    e: React.MouseEvent<HTMLDivElement | HTMLSpanElement, MouseEvent> | React.KeyboardEvent,
    fn: () => void,
  ) {
    e.stopPropagation();
    fn();
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onClick}
      className={styles['ellipsis-menu-container']}
      data-testid="ellipsis-menu"
      aria-label="menu"
      ref={ref as React.RefObject<HTMLDivElement>}
    >
      <FAIcon iconName="ellipsis-v" />
      {showMenu && (
        <div onBlur={onBlur} className={styles['ellipsis-menu-list']} data-testid="ellipsis-menu-list">
          {data.map(({ tabName, onTabClick = () => null }, index) => (
            <div className={styles['ellipsis-menu-list-container']} key={`List${index + 1}`}>
              <div
                key={uniqueId()}
                role="button"
                tabIndex={0}
                onClick={(e) => handleClick(e, onTabClick)}
                onKeyDown={(e) => handleClick(e, onTabClick)}
                className={styles['ellipsis-menu-list-container-item']}
                aria-label={tabName}
              >
                {tabName}
              </div>
              {tabName === allAllToList && (
                <FAIcon iconName="heart" iconStyle={IconStyle.REGULAR} onClick={(e) => handleClick(e, onTabClick)} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
